export default __webpack_public_path__ + "static/media/Gwent-YPMod1-ParticipantGuide.a5165209.pdf";